import React from 'react';

export interface IStickyFilterMetaItemProps {
  /** 左侧灰色标签，如「显示 事件」 */
  label: string;
  /** 右侧主值，如「显示 / Show」 */
  value: string;
  /** 点击主值时的回调（如切换展示类开关） */
  onValueClick?: () => void;
  /** 标签与值右侧的扩展区（如图标按钮） */
  extra?: React.ReactNode;
  className?: string;
}

/**
 * 吸顶筛选条末尾「非表单筛选」摘要项：与 `FilterTitle` 中 dim-item 视觉对齐，
 * 便于各页面在 `stickyTrailingSlot` 内组合多个元信息块。
 */
const StickyFilterMetaItem: React.FC<IStickyFilterMetaItemProps> = ({
  label,
  value,
  onValueClick,
  extra,
  className = '',
}) => {
  const clickable = Boolean(onValueClick);
  return (
    <div
      className={`dbd-filter-content-title-item dbd-filter-content-title-dim-item dbd-filter-sticky-meta-item ${className}`.trim()}
    >
      <span className="dbd-filter-content-title-item-name">{label}</span>
      <span
        className={
          clickable ? 'dbd-filter-sticky-meta-value is-clickable' : undefined
        }
        /**
         * 仅当传入 onValueClick 时才绑 click：避免「未传回调」的纯展示场景仍 stopPropagation，
         * 导致整个吸顶字段点击无法冒泡到 NewFilter 根 Card 触发筛选器展开。
         */
        onClick={
          clickable
            ? (e: React.MouseEvent) => {
              e.stopPropagation();
              onValueClick?.();
            }
            : undefined
        }
        onKeyDown={
          clickable
            ? (e: React.KeyboardEvent) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onValueClick?.();
              }
            }
            : undefined
        }
        role={clickable ? 'button' : undefined}
        tabIndex={clickable ? 0 : undefined}
      >
        {value}
      </span>
      {extra}
    </div>
  );
};

export default StickyFilterMetaItem;
